import React from 'react'
import { formatMoney } from '@ztechapps/common.utils'

export const LineItemContainer = ({ label, value }) => {
  return (
    <div className="list-group-item d-flex justify-content-between">
      <div>{label}</div>
      <div>{formatMoney(value)}</div>
    </div>
  )
}
